/**
 * MILKSO Ultra-Performance Lazy Loader & Smooth Navigation Engine
 * Handles smooth image fade-in loading & smooth menu navigation.
 */

(function () {
  'use strict';

  // 1. IMAGE LAZY LOADING WITH SMOOTH BLUR-UP FADE
  function initImageLazyLoading() {
    var images = document.querySelectorAll('img[loading="lazy"], img[data-src]');
    
    images.forEach(function (img) {
      if (!img.classList.contains('milkso-lazy-init')) {
        img.classList.add('milkso-lazy-init');
        if (!img.complete) {
          img.classList.add('milkso-lazy-loading');
        } else {
          img.classList.add('milkso-lazy-loaded');
        }

        img.addEventListener('load', function () {
          img.classList.remove('milkso-lazy-loading');
          img.classList.add('milkso-lazy-loaded');
        });
      }
    });

    if ('IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            if (image.dataset.src) {
              image.src = image.dataset.src;
            }
            image.classList.add('milkso-lazy-visible');
            observer.unobserve(image);
          }
        });
      }, {
        rootMargin: '120px 0px',
        threshold: 0.05
      });

      images.forEach(function (image) {
        imageObserver.observe(image);
      });
    } else {
      images.forEach(function (image) {
        image.classList.add('milkso-lazy-visible');
      });
    }
  }

  // 2. SMOOTH MENU NAVIGATION & ANCHOR SCROLLING
  function initSmoothMenuNavigation() {
    // Add top page progress indicator bar
    var progressBar = document.createElement('div');
    progressBar.className = 'milkso-page-progress';
    document.body.appendChild(progressBar);

    // Smooth anchor clicks
    document.addEventListener('click', function (e) {
      var anchor = e.target.closest('a[href*="#"], .mhdr__nav-link, .mhdr__mobile-link');
      if (!anchor) return;

      var href = anchor.getAttribute('href');
      if (!href) return;

      // Handle anchor links on the same page
      if (href.includes('#')) {
        var parts = href.split('#');
        var path = parts[0];
        var hash = parts[1];

        if (hash && (path === '' || path === window.location.pathname || path === '/')) {
          var targetEl = document.getElementById(hash) || document.querySelector('.' + hash) || document.querySelector('[data-section-id="' + hash + '"]');
          
          if (targetEl) {
            e.preventDefault();

            // Close mobile menu drawer if open
            var mobileDrawer = document.querySelector('.mhdr__mobile');
            var hamburger = document.querySelector('.mhdr__hamburger');
            if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
              mobileDrawer.classList.remove('is-open');
              if (hamburger) hamburger.classList.remove('is-active');
            }

            // Animate top progress bar
            progressBar.style.width = '70%';
            progressBar.style.opacity = '1';

            var headerHeight = 70;
            var targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });

            setTimeout(function () {
              progressBar.style.width = '100%';
              setTimeout(function () {
                progressBar.style.opacity = '0';
                progressBar.style.width = '0%';
              }, 200);
            }, 400);

            // Update active menu link state
            updateActiveMenuLink(anchor);
          }
        }
      } else if (href.startsWith('/') || href.startsWith(window.location.origin)) {
        // Page transition trigger for different page menu links
        progressBar.style.width = '55%';
        progressBar.style.opacity = '1';
      }
    });

    // 3. SCROLL SPY FOR ACTIVE MENU ITEM HIGHLIGHTING
    var sections = document.querySelectorAll('section, [id^="shopify-section-"], .milkso-why-section, .milkso-nutrition-section, .milkso-contact-section');
    var navLinks = document.querySelectorAll('.mhdr__nav-link, .mhdr__mobile-link');

    function onScrollSpy() {
      var scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      var headerHeight = 80;

      sections.forEach(function (sec) {
        var top = sec.offsetTop - headerHeight - 100;
        var bottom = top + sec.offsetHeight;
        var id = sec.getAttribute('id');

        if (id && scrollPos >= top && scrollPos < bottom) {
          navLinks.forEach(function (link) {
            var href = link.getAttribute('href') || '';
            if (href.includes('#' + id)) {
              updateActiveMenuLink(link);
            }
          });
        }
      });
    }

    window.addEventListener('scroll', throttle(onScrollSpy, 100));
  }

  function updateActiveMenuLink(activeLink) {
    var allLinks = document.querySelectorAll('.mhdr__nav-link, .mhdr__mobile-link');
    allLinks.forEach(function (link) {
      link.classList.remove('mhdr__nav-link--active', 'is-active');
    });
    if (activeLink) {
      activeLink.classList.add('mhdr__nav-link--active', 'is-active');
    }
  }

  function throttle(func, limit) {
    var inThrottle;
    return function () {
      var args = arguments;
      var context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(function () { inThrottle = false; }, limit);
      }
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initImageLazyLoading();
      initSmoothMenuNavigation();
    });
  } else {
    initImageLazyLoading();
    initSmoothMenuNavigation();
  }

  // Re-run lazyload on dynamic section updates
  document.addEventListener('shopify:section:load', function () {
    initImageLazyLoading();
  });
})();
